import { styled } from '@mui/material/styles';
import { inputBaseClasses } from '@mui/material/InputBase';
import TextInput from '../../../../library/TextInput';
import Button from '../../../../library/Button';

export const StyledTextInput = styled(TextInput)(() => ({
  marginRight: '12px',

  [`& .${inputBaseClasses.input}`]: {
    padding: '8.5px 12px 8.5px 16px',
  },
}));

export const StyledContentWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'flex-start',
}));

export const StyledButton = styled(Button)({
  wordBreak: 'normal',
});
